import Layout from '@components/Layout';
import Register from '@containers/Register';
import { middlewareLogin } from '@helpers/middleware';
import { ITitle } from '@interfaces/ITitle';
import type { NextPage, NextPageContext } from 'next';

const RegisterPage: NextPage<ITitle> = ({ title }): JSX.Element => {
  return (
    <Layout
      title={title}
      isNavbar={false}
      isSidebar={false}
      isFullWidth
      bg="white"
    >
      <Register />
    </Layout>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  return middlewareLogin(context, {
    title: 'Register',
  });
}

export default RegisterPage;